export default __webpack_public_path__ + "static/media/video-full-screen.f7285af6.svg";